import { useMutation } from '@tanstack/react-query';
import { useMixpanel } from 'react-mixpanel-browser';

import { refreshCachedDevice } from '@/api/devices';
import { PostActivateTimefencePayload, PostActivateTimefenceResponse } from '@/api/timefence/types';
import { axios } from '@/common/axios';
import { MutationConfig } from '@/common/react-query';
import { useErrorContext } from '@/context/ErrorContext';

export const postActivateTimefence = (
    payload: PostActivateTimefencePayload
): Promise<PostActivateTimefenceResponse> => {
    return axios.post('/device/activate-timefence', payload);
};

type UsePostActivateTimefenceOptions = {
    config?: MutationConfig<typeof postActivateTimefence>;
    data?: PostActivateTimefencePayload;
};

export const usePostActivateTimefence = ({ config }: UsePostActivateTimefenceOptions = {}) => {
    const { createErrorHandler } = useErrorContext();
    const mixpanel = useMixpanel();
    return useMutation({
        ...config,
        mutationFn: postActivateTimefence,
        onSuccess: (_data, variables) => {
            refreshCachedDevice(variables.spotterId);
            mixpanel?.track('Timefence activated', {
                spotterId: variables.spotterId,
            });
        },
        onError: createErrorHandler('activate timefence'),
    });
};
